module.exports = __webpack_public_path__ + "img/logo.abf03339.png";